export * from './connect'
export * from './name'

import { readGlobalState } from '@controllers/AlgorandController'
import AlgorandNetwork from '@providers/AlgorandNetwork'

export const handleGetRemainedTokenCountAlgo = async (
    provider: AlgorandNetwork,
    contractAddress: string[],
    setCurrentContractAddress: React.Dispatch<React.SetStateAction<number>>,
    setIsSoldOut: React.Dispatch<React.SetStateAction<boolean>>,
): Promise<number> => {
    const algoProvider = provider.getDefaultProvider()

    let tokenIdCounter = 0
    let totalSupply = 0
    // this will force to change contract addressess until the last one
    for (let index = 0; index < contractAddress.length; index++) {
        const appInfo = await algoProvider.getApplicationByID(Number.parseInt(contractAddress[index])).do()
        const globalState = await readGlobalState(algoProvider, appInfo.id)

        const total_supply = globalState['TS'] as number // string
        const total_count_key = globalState['TC'] as number // string
        if (total_count_key < total_supply) {
            setCurrentContractAddress(index)
            tokenIdCounter = total_count_key
            totalSupply = total_supply
            break
        } else if (total_count_key === total_supply * contractAddress.length) {
            setIsSoldOut(true)
        }
    }

    return totalSupply * contractAddress.length - tokenIdCounter
}
